<div class="gallery-container-wrapper">
  <div [ngSwitch]="type">
    <div *ngSwitchCase="1" class="title">
      <span>Pick-up Photos</span>&nbsp;<i class="fa fa-arrow-up"></i>
    </div>
    <div *ngSwitchCase="3" class="title">
      <span>Drop-off Photos</span>&nbsp;<i class="fa fa-arrow-down"></i>
    </div>
  </div>
  <div class="gallery-container">
    <div class="control-panel" *ngIf="(images && images.length > 0) || showAddButton">
      <div class="filters" *ngIf="images && images.length > 0">
        <div style="padding-left: 20px; padding-top: 10px">
          <div
            *ngFor="let filter of conditionFilters"
            class="filter-wrapper condition p-1 mb-2"
            [class.disabled]="!filter.enabled"
            (click)="filter.enabled = !filter.enabled; this.refreshImages()"
          >
            <div class="flex">
              <div class="flex align-items-center">
                <div>
                  <i class="las" [class]="filter.enabled ? 'la-check' : 'la-times'"></i>
                  <label class="filter-title">{{ filter.title }}</label>
                </div>
              </div>
              <div class="flex align-items-center">
                <div class="filter-amount">{{ filter.amount }}</div>
              </div>
            </div>
          </div>
        </div>
        <div style="padding-left: 20px">
          <div class="filter-wrapper description">
            <p-checkbox
              binary="true"
              [(ngModel)]="descriptionFilter.enabled"
              (onChange)="handleChangeFilter()"
            ></p-checkbox>
            <label>{{ descriptionFilter.label }}</label>
          </div>

          <div class="filter-wrapper signature">
            <p-checkbox
              binary="true"
              [(ngModel)]="signaturesFilter.enabled"
              (onChange)="handleChangeFilter()"
            ></p-checkbox>
            <label>{{ signaturesFilter.label }}</label>
          </div>
        </div>
      </div>
    </div>
    <div class="" *ngIf="images && images.length > 0; else notfound">
      <div *ngIf="galleryImages && galleryImages.length; else empty">
        <div *ngIf="selectedImage" class="selected-image-info">
          <div class="main-info-wrapper flex">
            <div class="flex-grow-1">
              <span class="area">{{ selectedImage.areaTitle }}</span>
              <span class="condition" *ngIf="!selectedImage.isSignature">{{
                selectedImage.conditionTitle
              }}</span>
            </div>
            <div class="flex-shrink-1">
              <span class="date">{{ selectedImage.dateTime | datex : 'ddd DD MMM HH:mm' }}</span>
            </div>
          </div>
          <div
            *ngIf="!selectedImage.isSignature && selectedImage.conditionComment"
            class="condition-wrapper"
          >
            <span>Vehicle Condition: {{ selectedImage.conditionComment }}</span>
          </div>
          <div class="description-wrapper" *ngIf="selectedImage.description?.length > 0">
            <span class="description">{{ selectedImage.description || '&nbsp;' }}</span>
          </div>
        </div>
        <div style="padding: 0 20px">
          <div style="background-color: #efefef; padding: 10px 0">
            <ngx-gallery
              [options]="galleryOptions"
              [images]="galleryImages"
              [selectedStyle]="selectedStyle"
              (change)="handleSelectedImageChange($event)"
            ></ngx-gallery>
          </div>
        </div>
      </div>
      <ng-template #empty>
        <div class="flex align-content-center justify-content-center">
          <div class="notfound filter">Empty. Please change filtering parameters.</div>
        </div>
      </ng-template>
    </div>
    <ng-template #notfound>
      <div class="flex justify-content-center">
        <div class="notfound pt-2">
          <div><b>No photo images have been uploaded for this task step.</b></div>
          <div class="task-must-begin">Task must begin before driver can import photos</div>
        </div>
      </div>
    </ng-template>

    <div class="text-right" style="padding: 20px 20px 10px 0">
      <div class="buttons">
        <button
          type="button"
          (click)="viewOdometerImage()"
          pButton
          label="Open Odometer"
          class="ui-button ui-button-tertiary mb-2 btn-mobile-block"
        ></button>

        <button
          *ngIf="showAddButton"
          type="button"
          (click)="setAreaCondition()"
          pButton
          label="Set Area Condition"
          [disabled]="disableAddButton"
          class="ui-button ui-button-tertiary mb-2 btn-mobile-block"
        ></button>

        <button
          *ngIf="showAddButton"
          type="button"
          (click)="deletePhoto()"
          pButton
          icon="fa ui-icon-trash"
          label="Delete Photo"
          [disabled]="!selectedImage"
          class="ui-button red-btn mb-2 btn-mobile-block"
        ></button>
        <button
          *ngIf="showAddButton"
          type="button"
          (click)="editPhoto()"
          pButton
          icon="fa ui-icon-edit"
          label="Edit Photo"
          [disabled]="!selectedImage"
          class="ui-button ui-button-tertiary mb-2 btn-mobile-block"
        ></button>
        <button
          *ngIf="showAddButton"
          type="button"
          (click)="addPhoto()"
          pButton
          icon="fa ui-icon-add-to-photos"
          label="Add Photo/PDF"
          [disabled]="disableAddButton"
          class="ui-button mb-2 btn-mobile-block"
        ></button>
      </div>
    </div>
  </div>
</div>
